import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class NoticeDialogService {

  constructor(private dialog: MatDialog) {}

  show(title: string, message: string, width: string = '500px') {
    return this.dialog.open(InfoDialogComponent, {
      width: width,
      disableClose: true,
      data: {
        title: title,
        message: message
      }
    });
  }

  blockButton() {
    return this.show(
      'PEMAKLUMAN',
      `Dimaklumkan aktiviti penyenggaraan eFiling akan diadakan seperti berikut:
      
      <b>Tarikh : 05 Jun 2026  Sehingga 06 Jun 2026</b>
      <b>Masa  : 5.30 petang  Sehingga 12.00 tengahari</b>
      
      Sehubungan itu, capaian ke menu eFiling bagi 
      <b>borang BE / B / BT / M / MT  Tahun Taksiran 2025</b> 
      tidak dapat diakses sepanjang tempoh tersebut.
      
      Mohon maaf atas kesulitan yang dialami.

      Sekian, terima kasih`
    );
  }
}